import React from "react";
import { ORDERS_NS } from "@/i18n/ns";
import PT from "prop-types";
import { useForm, FormContext } from "react-hook-form";
import { AbstractControlledField, AbstractField } from "_c/form/Field";
import Calendar from "_c/Calendar";
import { useTheme } from "@/hooks/useTheme";
import { useSortOptions, useLocOptions } from "./hooks";
import { CircleButton } from "_c/button";
import DenyIcon from "_c/icon/Deny";
import Switch from "react-switch";
import Modal, { Header, Footer, Content } from "_c/Modals";
import { useOrdersSortBy } from "../hooks";

const ns = `${ORDERS_NS}:search`;

const noSelect = "no";

const Filters = ({ t, query, ...props }) => {
  const [sortBy, setSortBy] = useOrdersSortBy();
  const theme = useTheme();
  const locOpts = useLocOptions({ t });
  const sortOpts = useSortOptions({ t });
  const methods = useForm({
    defaultValues: {
      sort_by: sortBy,
      has_review: Boolean(query.has_review),
      has_note: Boolean(query.has_note),
      safe: Boolean(query.safe),
      location_type: query.location_type || noSelect,
      range:
        query.range_start && query.range_end
          ? [new Date(query.range_start), new Date(query.range_end)]
          : null,
    },
  });
  const { setValue, watch } = methods;
  const range = watch("range");
  const { handleSubmit } = methods;
  const onSubmit = ({ range, sort_by, location_type, ...form }) => {
    if (sort_by) {
      setSortBy(sort_by);
    }
    const query = {
      ...form,
      range_start: range?.[0]?.toISOString(),
      range_end: range?.[1]?.toISOString(),
      location_type: location_type === noSelect ? undefined : location_type,
      sort_by: sort_by,
    };
    props.updateQuery(query);
    props.onClose();
  };
  return (
    <>
      <Header onClick={props.onClose}>{t("common:close")}</Header>
      <Content>
        <FormContext {...methods}>
          <form id="task-filters" onSubmit={handleSubmit(onSubmit)}>
            <AbstractField
              t={t}
              id="search__sort"
              Component="select"
              className="simpo-native-select"
              label={t(`${ns}.sort`)}
              name="sort_by"
            >
              {sortOpts.map(({ value, label }) => (
                <option value={value} key={value}>
                  {label}
                </option>
              ))}
            </AbstractField>
            <div style={{ position: "relative" }}>
              {range && (
                <CircleButton
                  type="button"
                  style={{
                    position: "absolute",
                    right: "10px",
                    bottom: "15px",
                  }}
                  negative
                  small
                  onClick={() => setValue("range", null)}
                >
                  <DenyIcon color="white" width="10" />
                </CircleButton>
              )}
              <AbstractControlledField
                name="range"
                id="search_range"
                label={t(`${ns}.range`)}
                Component={Calendar}
                options={{
                  mode: "range",
                }}
              />
            </div>
            <AbstractControlledField
              id="search_loc"
              name="location_type"
              Component="select"
              className="simpo-native-select"
              label={t(`${ns}.loc_type.label`)}
            >
              <option value={noSelect}>{t("common:not_selected")}</option>
              {locOpts.map(({ value, label }) => (
                <option value={value} key={value}>
                  {label}
                </option>
              ))}
            </AbstractControlledField>
            {/*<AbstractControlledField
              id="search_safe"
              name="safe"
              Component={Switch}
              onColor={theme.color.positive}
              offColor={theme.color.negative}
              checkedIcon={null}
              uncheckedIcon={null}
              label={t(`${ns}.safe`)}
            />
            */}
            <AbstractControlledField
              id="search_has_review"
              onColor={theme.color.primary}
              checkedIcon={null}
              uncheckedIcon={null}
              name="has_review"
              Component={Switch}
              label={t(`${ns}.has_review`)}
            />
            <AbstractControlledField
              onColor={theme.color.primary}
              checkedIcon={null}
              uncheckedIcon={null}
              id="search_has_note"
              name="has_note"
              Component={Switch}
              label={t(`${ns}.has_note`)}
            />
          </form>
        </FormContext>
      </Content>
      <Footer type="submit" form="task-filters">
        {t("common:accept")}
      </Footer>
    </>
  );
};
Filters.propTypes = {
  query: PT.object.isRequired,

  updateQuery: PT.func.isRequired,
  onClose: PT.func.isRequired,
  t: PT.func.isRequired,
};

const FiltersModal = (props) => {
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose}>
      <Filters {...props} />
    </Modal>
  );
};
export default FiltersModal;
